export const API_URL = "https://api.openweathermap.org/data/2.5/";

export const API_KEY = "caa883a4a60d93878755b08a933f74ea";
